import { Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FadeOutContainer, IconContainer } from '../components';
import { useSidebarMenu } from '../useSidebarMenu';
import { StyledButton, StyledFadeOutSpacer } from './styled';
export function SidebarMenuSearch(props) {
    const { label, shortcutLabel, onClick } = props;
    const { minimized } = useSidebarMenu();
    return (<StyledButton size="small" appearance="secondary" onClick={onClick}>
      <IconContainer>
        <Falcon icon="search"/>
      </IconContainer>
      <FadeOutContainer $minimized={minimized}>
        <StyledFadeOutSpacer>
          {label}
          <Chip size="small" appearance="secondary" label={shortcutLabel}/>
        </StyledFadeOutSpacer>
      </FadeOutContainer>
    </StyledButton>);
}
